module.exports = __webpack_public_path__ + "41f76644b2bbdb09bc3ccc3e62210b67.pdf";